import React, { useContext, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { LoginContext } from '../../context/loginContext';
import { apiClient } from '../../config/apiClient';
import MainLayout from '../layout/layout';
import TerminalFichada from './terminalFichada';

const FichadaProfesorPage = () => {
  const { user } = useContext(LoginContext);
  const [profesorAutenticado, setProfesorAutenticado] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      if (!user?.usu_id) {
        setLoading(false);
        return;
      }
      try {
        const res = await apiClient.get(`/profesores/${user.usu_id}`);
        if (res.ok) {
          const p = await res.json();
          setProfesorAutenticado({
            id: p.pro_id,
            nombre: p.pro_nombre,
            apellido: p.pro_apellido,
            usuario: p.pro_usuario,
          });
        }
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, [user?.usu_id]);

  if (loading) {
    return (
      <MainLayout>
        <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
          <Spin size="large" />
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <TerminalFichada
        tipoPersonaInicial="profesor"
        profesorAutenticado={profesorAutenticado}
      />
    </MainLayout>
  );
};

export default FichadaProfesorPage;
